<template>
    <div class="row align-items-center justify-content-center mt-4">
        <div class="col-12 col-lg-7 pb-4">
            <div class="formulario w-100 p-4">
                <form @submit.prevent="handleSubmit">
                    <div class="row mb-3">
                        <label
                            class="col-12 col-lg-2 col-form-label pr-0 text-left text-lg-right textogeneral"
                            for="names"
                        >Nombres</label>
                        <div class="col-12 col-lg-10">
                            <input
                                class="form-control"
                                id="names"
                                type="text"
                                :class="{ 'is-invalid' : errors.names }"
                                v-model="form.names"
                            >
                            <invalid-feedback :error="errors.names"></invalid-feedback>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <label
                            class="col-12 col-lg-2 col-form-label pr-0 text-left text-lg-right textogeneral"
                            for="last_names"
                        >Apellidos</label>
                        <div class="col-12 col-lg-10">
                            <input
                                class="form-control"
                                id="last_names"
                                type="text"
                                :class="{ 'is-invalid' : errors.last_names }"
                                v-model="form.last_names"
                            >
                            <invalid-feedback :error="errors.last_names"></invalid-feedback>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <label
                            class="col-12 col-lg-2 col-form-label pr-0 text-left text-lg-right textogeneral"
                            for="email"
                        >Correo</label>
                        <div class="col-12 col-lg-10">
                            <input
                                class="form-control"
                                id="email"
                                type="email"
                                :class="{ 'is-invalid' : errors.email }"
                                v-model="form.email"
                            >
                            <invalid-feedback :error="errors.email"></invalid-feedback>
                        </div>
                    </div>
                    <div class="row mb-3 form-group">
                        <label
                            class="col-12 col-lg-2 col-form-label pr-0 text-left text-lg-right textogeneral"
                            for="country"
                        >Pais</label>
                        <div class="col-12 col-lg-10">
                            <select
                                class="form-control"
                                id="country"
                                name="country"
                                :class="{ 'is-invalid' : errors.country }"
                                v-model="form.country"
                            >
                                <option value="">Seleccionar</option>
                                <option :value="country" v-for="country in countries">{{ country }}</option>
                            </select>
                            <invalid-feedback :error="errors.country"></invalid-feedback>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-10 offset-lg-2 offset-md-0 col-md-12 text-center">
                            <button
                                :disabled="loading"
                                class="btn btn-primary btn-block text-uppercase"
                                type="submit"
                            >Enviar inscripción</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import InvalidFeedback from  './InvalidFeedback'

    export default {
        props: {
            countries: Array,
            route: String
        },
        data() {
            return {
                errors: [],
                form: {
                    country: '',
                    email: null,
                    last_names: null,
                    names: null
                },
                loading: false
            }
        },
        methods: {
            handleSubmit () {
                this.loading = true

                axios.post(this.route, this.form)
                .then(response => {
                    const { inscription } = response.data
                    window.location.href = `/transaction/${inscription.token}`
                }).catch(error => {
                    const { status } = error.response
                    if (status === 422) {
                        this.errors = error.response.data.errors
                    }
                }).then(() => {
                    this.loading = false
                })
            }
        },
        components: {
            'invalid-feedback': InvalidFeedback
        }
    }
</script>